__turbopack_context__.v({
  "checkmark": "Checklist-module-scss-module__NprxlW__checkmark",
  "fade-in": "Checklist-module-scss-module__NprxlW__fade-in",
  "item": "Checklist-module-scss-module__NprxlW__item",
  "list": "Checklist-module-scss-module__NprxlW__list",
  "no-transform": "Checklist-module-scss-module__NprxlW__no-transform",
  "rotate": "Checklist-module-scss-module__NprxlW__rotate",
});
